import { FC } from "react";

interface ChartGradientProps {
  color: string;
}
export const ChartGradient: FC<ChartGradientProps> = ({ color }) => (
  <defs>
    <linearGradient id="areaGradient" x1="0" x2="0" y1="0" y2="1">
      <stop offset="0%" stopColor={color} stopOpacity={0.9} />
      <stop offset="0%" stopColor={color} stopOpacity={0.6} />
      <stop offset="65%" stopColor={color} stopOpacity={0.3} />
      <stop offset="85%" stopColor={color} stopOpacity={0.07} />
      <stop offset="100%" stopColor={color} stopOpacity={0.04} />
    </linearGradient>
  </defs>
);
